import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import LeftComponent from "../components/LeftComponent";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import "../css/invoiceScreen.css";
import {
  createSubAgentInvoices,
  listSubAgentInvoices,
} from "../actions/InvoiceSubAgentActions";
import { subagentInvoiceFilter } from "../models/subagentModel";
import SubAgent from "../components/SubAgent";
import Month from "../components/Month";
import Year from "../components/Year";
import {
  subagentInternalInvoiceJson,
  subagentInvoiceJson,
} from "../models/invoiceModel";
import { INVOICE_SUB_AGENT_CREATE_RESET } from "../constants/invoiceSubAgentConstants";
import { createSubAgentInternalInvoices } from "../actions/InvoiceSubAgentInternalActions";
import {
  INVOICE_SUB_AGENT_INTERNAL_CREATE_REQUEST,
  INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET,
} from "../constants/invoiceSubAgentInternalConstants";

export default function InvoiceSubAgentScreen(props) {
  const dispatch = useDispatch();

  const applyPageFilter = () => {};
  const [invoiceFilter, setInvoiceFilter] = useState(subagentInvoiceFilter);

  const [showAddSAInvoice, setshowAddSAInvoice] = useState(false);
  const [sainvoiceData, setsainvoiceData] = useState(subagentInvoiceJson);

  const [showAddSAInternalInvoice, setshowAddSAInternalInvoice] =
    useState(false);
  const [saInternalInvoiceData, setsaInternalInvoiceData] = useState(
    subagentInternalInvoiceJson
  );

  const { loading, error, subagentInvoices, subagentInvoiceTotal } =
    useSelector((s) => s.subAgentInvoiceList);

  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
  } = useSelector((s) => s.subAgentInvoiceCreate);

  const {
    loading: loadingCreateInternal,
    error: errorCreateInternal,
    success: successCreateInternal,
  } = useSelector((s) => s.subAgentInvoiceInternalCreate);

  const getSubAgentInvoices = () => {
    dispatch(listSubAgentInvoices(invoiceFilter));
  };

  const handleSearch = (e) => {
    setInvoiceFilter({ ...invoiceFilter, [e.target.name]: e.target.value });
  };

  const handleFilter = (e) => {
    setInvoiceFilter({ ...invoiceFilter, [e.target.name]: e.target.value });
    getSubAgentInvoices();
  };

  const handleAddSAInvoice = (e) => {
    setsainvoiceData({ ...sainvoiceData, [e.target.name]: e.target.value });
  };

  const handleAddSAInternalInvoice = (e) => {
    setsaInternalInvoiceData({
      ...saInternalInvoiceData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSAInvoiceSave = (e) => {
    e.preventDefault();
    dispatch(createSubAgentInvoices(sainvoiceData));
  };

  const handleSAInternalInvoiceSave = (e) => {
    e.preventDefault();
    dispatch(createSubAgentInternalInvoices(saInternalInvoiceData));
  };

  const insertSubAgentInvoice = (
    invoiceId,
    subAgentId,
    contactId,
    applicationId
  ) => {
    setsainvoiceData({
      ...sainvoiceData,
      Invoice_Id: invoiceId,
      Contact_Id: contactId,
      Application_Id: applicationId,
      Subagent_Id: subAgentId,
    });
    setshowAddSAInvoice(true);
  };

  const insertPaidSA = (invoiceId, subAgentId) => {
    setshowAddSAInternalInvoice(true);
    setsaInternalInvoiceData({
      ...saInternalInvoiceData,
      Invoice_Id: invoiceId,
      SubAgent_Id: subAgentId,
    });
  };

  useEffect(() => {
    if (!subagentInvoices) {
      getSubAgentInvoices();
    }
    if (successCreate) {
      setsainvoiceData({ ...subagentInvoiceJson });
      setTimeout(() => {
        dispatch({ type: INVOICE_SUB_AGENT_CREATE_RESET });
        setshowAddSAInvoice(false);
        getSubAgentInvoices();
      }, 2000);
    }
    if (successCreateInternal) {
      setsaInternalInvoiceData({ ...subagentInternalInvoiceJson });
      setTimeout(() => {
        dispatch({ type: INVOICE_SUB_AGENT_INTERNAL_CREATE_RESET });
        setshowAddSAInternalInvoice(false);
        getSubAgentInvoices();
      }, 2000);
    }
  }, [dispatch, subagentInvoices, successCreate, successCreateInternal]);

  return (
    <>
      <Header pageName="Sub Agent Invoice Dashboard" />
      <LeftComponent>
        <div className="subagent">
          <div
            id="myModal"
            className={showAddSAInvoice ? "modal d-block" : "modal"}
          >
            <div className="modal-content">
              <span
                className="close"
                onClick={(e) => {
                  setshowAddSAInvoice(false);
                  setsainvoiceData({ ...subagentInvoiceJson });
                }}
              >
                &times;
              </span>
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <label>Invoice Raised Date</label>
                    <p>
                      <input
                        type="date"
                        className="form-control"
                        name="InvoiceRaised_Date"
                        value={sainvoiceData.InvoiceRaised_Date}
                        onChange={(e) => handleAddSAInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label>Invoice Raised Amount</label>
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        name="InvoiceRaised_Amount"
                        value={sainvoiceData.InvoiceRaised_Amount}
                        onChange={(e) => handleAddSAInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label>Invoice Due Date</label>
                    <p>
                      <input
                        type="date"
                        className="form-control"
                        name="Invoice_Due_Date"
                        value={sainvoiceData.Invoice_Due_Date}
                        onChange={(e) => handleAddSAInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label>Invoice Due Amount</label>
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        name="Invoice_Due_Amount"
                        value={sainvoiceData.Invoice_Due_Amount}
                        onChange={(e) => handleAddSAInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p>
                      <input
                        type="button"
                        className="btn btn-sm btn-deep-orange"
                        value={!loadingCreate ? "Save" : "loading..."}
                        disabled={loadingCreate}
                        onClick={handleSAInvoiceSave}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="subagentInternal">
          <div
            id="myModal"
            className={showAddSAInternalInvoice ? "modal d-block" : "modal"}
          >
            <div className="modal-content">
              <span
                className="close"
                onClick={(e) => {
                  setshowAddSAInternalInvoice(false);
                  setsaInternalInvoiceData({ ...subagentInternalInvoiceJson });
                }}
              >
                &times;
              </span>
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <label>Paid Date</label>
                    <p>
                      <input
                        type="date"
                        className="form-control"
                        name="Paid_Date"
                        value={saInternalInvoiceData.Paid_Date}
                        onChange={(e) => handleAddSAInternalInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-6">
                    <label>Paid Amount</label>
                    <p>
                      <input
                        type="text"
                        className="form-control"
                        name="Paid_To_Subagent"
                        value={saInternalInvoiceData.Paid_To_Subagent}
                        onChange={(e) => handleAddSAInternalInvoice(e)}
                      />
                    </p>
                  </div>
                  <div className="col-md-12">
                    <label>Any Comments</label>
                    <p>
                      <textarea
                        className="form-control"
                        name="Any_Comments"
                        rows={2}
                        value={saInternalInvoiceData.Any_Comments}
                        onChange={(e) => handleAddSAInternalInvoice(e)}
                      ></textarea>
                    </p>
                  </div>

                  <div className="col-md-12">
                    <p>
                      <input
                        type="button"
                        className="btn btn-sm btn-deep-orange"
                        value={!loadingCreateInternal ? "Save" : "loading..."}
                        disabled={loadingCreateInternal}
                        onClick={handleSAInternalInvoiceSave}
                      />
                    </p>
                    <p>{errorCreateInternal ? errorCreateInternal : ""}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="content-body">
          <div className="container-fluid">
            <div className="inner-body">
              <div className="row">
                <div className="col-md-3 col-lg-2">
                  <div className="filter-in-mob-view text-right">
                    <input
                      type="text"
                      name="searchtxt"
                      placeholder="Search Invoice Id..."
                      value={invoiceFilter.searchtxt}
                      onChange={(e) => handleSearch(e)}
                    />
                    <i className="fas fa-filter mob-nav-open"></i>
                  </div>
                  {/* <!-- /filter-in-mob-view --> */}

                  <div className="add-filter">
                    <div className="filter-title  filter-title-mob">
                      <h5>Filter Invoices </h5>
                      <button className="mob-nav-open">☰</button>
                    </div>
                    <div className="filter-body filter-body-mob custom-scroll-right pt-0">
                      <div className="sticky pt-2">
                        <h6>
                          <strong>Overdue Invoices</strong>
                        </h6>

                        <p>
                          Total{" "}
                          {subagentInvoiceTotal ? subagentInvoiceTotal : "0"}{" "}
                          Invoices
                        </p>

                        <button className="btn btn-sm btn-deep-orange">
                          Reset filters
                        </button>
                      </div>

                      <ul className="modify-filter-title">
                        <li>Sub Agent:</li>
                        <li>
                          <select
                            className="form-control"
                            name="subagentid"
                            value={invoiceFilter.subagentid}
                            onChange={(e) => handleFilter(e)}
                          >
                            <option value="">--Select--</option>
                            <SubAgent />
                          </select>
                        </li>
                        <li>Month:</li>
                        <li>
                          <select
                            className="form-control"
                            name="month"
                            value={invoiceFilter.month}
                            onChange={(e) => handleFilter(e)}
                          >
                            <option value="">--Select--</option>
                            <Month />
                          </select>
                        </li>
                        <li>Year:</li>
                        <li>
                          <select
                            className="form-control"
                            name="year"
                            value={invoiceFilter.year}
                            onChange={(e) => handleFilter(e)}
                          >
                            <option value="">--Select--</option>
                            <Year />
                          </select>
                        </li>

                        <li>
                          Invoiced Raised Date <br />
                          From:
                        </li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="invoicedRaisedFrom"
                            value={invoiceFilter.invoicedRaisedFrom}
                            onChange={(e) => handleFilter(e)}
                          />
                        </li>
                        <li>To:</li>
                        <li>
                          <input
                            type="date"
                            className="form-control"
                            name="invoicedRaisedTo"
                            value={invoiceFilter.invoicedRaisedTo}
                            onChange={(e) => handleFilter(e)}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-md-9 col-lg-10">
                  <div className="row">
                    <div className="col-md-12 ">
                      <div className="home-table-search float-right d-flex">
                        <div
                          className="input-group search-contacts"
                          style={{ paddingBottom: "10px" }}
                        >
                          <input
                            type="text"
                            id="searchContact"
                            className="form-control ng-pristine ng-valid ng-empty ng-touched"
                            placeholder="Search Invoice"
                            name="searchtxt"
                            // value={invoiceData.searchtxt}
                            // onChange={(e) => {
                            //   setInvoices(e);
                            // }}
                            // onKeyDown={(e) => {
                            //   if (e.key === "Enter") {
                            //     applySearchFilter();
                            //   }
                            // }}
                          />
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                            // onClick={applySearchFilter}
                          ></i>
                        </div>
                        {/* <div className="right-click Create-btn">
                          <a className="btn create-contact">Create Invoice</a>
                        </div> */}
                      </div>
                      {/* <input type="text" className="form-control sm" />
                                            <Link to="/invoice/create" target="_blank" className='a-btn'>Add Invoice</Link> */}
                    </div>
                  </div>

                  <div className="coctacts-table">
                    <div className="table-responsive custom-scroll-right-bottum">
                      <table className="table table-condensed ">
                        <thead className="t-head-th-bg">
                          <tr>
                            <th className="t-head-fixed">Actions</th>
                            <th className="t-head-fixed">Sub Agent Name</th>
                            <th className="t-head-fixed">Student Name</th>
                            <th className="t-head-fixed">University Name</th>
                            <th className="t-head-fixed">Course Name</th>
                            <th className="t-head-fixed">Intake Month-Year</th>
                            <th className="t-head-fixed">
                              Invoice Create Date
                            </th>
                            <th className="t-head-fixed">Payment Received</th>
                            <th className="t-head-fixed">Payment RVD Amount</th>
                            <th className="t-head-fixed">Payment Due Date</th>
                            <th className="t-head-fixed">Payment Due Amount</th>
                            <th className="t-head-fixed">
                              Invoiced Raised By SA
                            </th>
                            <th className="t-head-fixed">
                              Invoice Raised Amount
                            </th>
                            <th className="t-head-fixed">
                              Payment Made to SA Date
                            </th>
                            <th className="t-head-fixed">
                              Payment Amount Made to SA
                            </th>
                            <th className="t-head-fixed">SA Invooice File</th>
                          </tr>
                        </thead>
                        <tbody className="table-bordered">
                          {subagentInvoices ? (
                            subagentInvoices.length > 0 ? (
                              subagentInvoices.map((recs, index) => (
                                <tr key={index + 1}>
                                  <td>
                                    <a
                                      onClick={(e) => {
                                        insertSubAgentInvoice(
                                          recs.Id,
                                          recs.Referral_SubAgent_Id,
                                          recs.Contact_Id,
                                          recs.Application_Id
                                        );
                                      }}
                                      style={{
                                        backgroundColor: "green",
                                        padding: "3px",
                                      }}
                                    >
                                      Add Details
                                    </a>
                                    <a
                                      onClick={(e) => {
                                        setshowAddSAInternalInvoice(true);
                                        insertPaidSA(
                                          recs.Id,
                                          recs.Referral_SubAgent_Id
                                        );
                                      }}
                                      style={{
                                        backgroundColor: "yellow",
                                        padding: "3px",
                                      }}
                                    >
                                      Mark Paid
                                    </a>
                                  </td>
                                  <td>{recs.SubAgent_Name}</td>
                                  <td>{recs.Contact_Name}</td>
                                  <td>{recs.University_Name}</td>
                                  <td>{recs.Course_Name}</td>
                                  <td>
                                    {recs.INTAKE_MONTH}-{recs.INTAKE_YEAR}
                                  </td>
                                  <td>{recs.Invoice_Created_Date}</td>
                                  <td>{recs.Payment_Due_Date}</td>
                                  <td>{recs.Payment_Recvd}</td>
                                  <td>{recs.Invoice_Raised_toUni}</td>
                                  <td></td>
                                  <td>{recs.InvoiceRaised_Date}</td>
                                  <td>{recs.InvoiceRaised_Amount}</td>
                                  <td>{recs.Paid_Date}</td>
                                  <td>{recs.AmountPaidToSA}</td>
                                  <td>{recs.Invoice_Doc}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10">No Record Exist!</td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td colSpan="10">{error}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="table-page-details">
                      <div className="row">
                        <div className="col-md-9">
                          <ReactPaginate
                            className="pagination justify-content-center"
                            activeClassName="activeClass"
                            breakLabel="..."
                            nextLabel="Next"
                            nextClassName="nextClass"
                            previousClassName="previousClass"
                            pageClassName="page-item"
                            //onPageChange={(e) => applyPageFilter(e)}
                            pageRangeDisplayed={5}
                            pageCount={
                              subagentInvoiceTotal
                                ? Math.ceil(
                                    subagentInvoiceTotal /
                                      subagentInvoiceFilter.PageSize
                                  )
                                : "1"
                            }
                            previousLabel="Previous"
                            renderOnZeroPageCount={null}
                            pageLinkClassName="page-link"
                          />
                        </div>
                        <div className="col-md-3 text-center">
                          <div className="page-counter">
                            <label>
                              Showing &nbsp;
                              <select
                                name="PageSize"
                                value={subagentInvoiceFilter.PageSize}
                              >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                              </select>{" "}
                              of <span>{subagentInvoiceTotal ? subagentInvoiceTotal : ""}</span> records
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LeftComponent>
    </>
  );
}
